/**
 *
 * Label Input
 *
 * @param {*} props
 *
 * props: {
 *   label: string
 *    hasValue: boolean
 * }
 *
 * @returns
 */
export const FieldLabel = (
  props = {
    label: undefined,
    require: false,
    hasInput: false
  }
) => {
  if (!props?.label) return <></>
  return (
    <div className={''}>
      <label
        className={`paragraph-sm font-bold text-primary-black transition-opacity ${
          props.hasInput ? 'opacity-100' : 'opacity-50'
        }`}
      >
        {props.label}
        {props?.required && '*'}
      </label>
    </div>
  )
}
